import React, { useState, useEffect } from "react";

const testimonialsData = [
  {
    name: " Abdul Mohammed",
    // designation: "MBBS, DNB - General Surgery",
    feedback:
      "Highly professional and patient-friendly. The online booking system is excellent!",
    image: "/assets/img/testmonials/testmonials1.jpg",
  },
  {
    name: "Prudhvinath",
    // designation: "MBBS, DNB - General Surgery",
    feedback:
      "Amazing consultation experience. I felt very comfortable and informed.",
    image: "/assets/img/testmonials/testmonials2.jpeg",
  },
  {
    name: " Anuj Kumar Patel",
    // designation: "MBBS, MS-General Surgery",
    feedback:
      "Excellent treatment and very helpful staff. Highly recommend this clinic!",
        image: "/assets/img/testmonials/testmonials1.jpg",
  },
  {
    name: " Sneha Reddy",
    // designation: "MBBS, DGO",
    feedback:
      "Smooth appointment booking and friendly staff. Very professional doctors.",
       image: "/assets/img/testmonials/testmonials2.jpeg",
  },
  {
    name: " Ravi Kumar",
    // designation: "MBBS, MS - Laparoscopy",
    feedback:
      "Quick consultation with detailed guidance. Absolutely satisfied!",
       image: "/assets/img/testmonials/testmonials1.jpg",
  },
  {
    name: " Priya Sharma",
    // designation: "MBBS, DNB - Dermatology",
    feedback:
      "The doctors are skilled and the process is seamless. Highly recommended!",
        image: "/assets/img/testmonials/testmonials2.jpeg",
  },
];

const TestimonialsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCount = 3;

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev + visibleCount >= testimonialsData.length ? 0 : prev + visibleCount
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev - visibleCount < 0
        ? testimonialsData.length - visibleCount
        : prev - visibleCount
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        background: "radial-gradient(circle at 50% 20%, #e7f2ff 0%, #ffffff 70%)",
        padding: "100px 20px",
        textAlign: "center",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <h2
        style={{
          fontSize: "42px",
          fontWeight: "800",
          color: "#0b1c39",
          marginBottom: "15px",
        }}
      >
        What Our <span style={{ color: "#ffcb24" }}>Patients Say</span>
      </h2>
      <p
        style={{
          fontSize: "18px",
          color: "#555",
          marginBottom: "40px",
          maxWidth: "600px",
          marginLeft: "auto",
          marginRight: "auto",
          lineHeight: 1.8,
        }}
      >
        Trusted experts providing the best care.
      </p>

      <div
        style={{
          position: "relative",
          maxWidth: "1200px",
          margin: "0 auto",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            transition: "transform 0.6s ease-in-out",
            transform: `translateX(-${
              (currentIndex / testimonialsData.length) * 100
            }%)`,
          }}
        >
          {testimonialsData.map((t, index) => (
            <div
              key={index}
              style={{
                minWidth: `${100 / visibleCount}%`,
                boxSizing: "border-box",
                padding: "0 15px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "20px",
                  padding: "25px 20px",
                  boxShadow: "0 15px 35px rgba(0,0,0,0.1)",
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "20px",
                  textAlign: "left",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                {/* Image */}
                <div
                  style={{
                    flexShrink: 0,
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "2px solid #ffcb24",
                  }}
                >
                  <img
                    src={t.image}
                    alt={t.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                </div>

                {/* Content */}
                <div style={{ flex: 1 }}>
                  <p
                    style={{
                      fontSize: "17px",
                      color: "#555",
                      fontStyle: "italic",
                      lineHeight: 1.8,
                      marginBottom: "15px",
                    }}
                  >
                    "{t.feedback}"
                  </p>
                  <h4
                    style={{
                      fontSize: "22px",
                      fontWeight: "600",
                      color: "#0b1c39",
                      margin: "0 0 5px",
                    }}
                  >
                    {t.name}
                  </h4>
                  <span style={{ fontSize: "17px", color: "#09bbaf" }}>
                    {t.designation}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Arrows */}
        <button
          onClick={prevSlide}
          style={{
            position: "absolute",
            top: "50%",
            left: "0",
            transform: "translateY(-50%)",
            background: "#ffcb24",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "18px",
            zIndex: 10,
          }}
        >
          ‹
        </button>
        <button
          onClick={nextSlide}
          style={{
            position: "absolute",
            top: "50%",
            right: "0",
            transform: "translateY(-50%)",
            background: "#ffcb24",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            cursor: "pointer",
            fontWeight: "700",
            fontSize: "18px",
            zIndex: 10,
          }}
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default TestimonialsCarousel;
